module.exports = __webpack_public_path__ + "jab/media/download.e1e354e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/download.svg
// module id = 199
// module chunks = 0